import { call, takeLatest } from "redux-saga/effects";
import { getToken } from "../../utils/common";
import axiosT1 from "../../utils/axios";
import API from "../../common/api_config";
import ACTIONS from "src/common/action_constant";


export function* getDevToolsConfig(action) {
  try {
    const resp = yield call(
      axiosT1.get,
      API.getDevToolConfigUrl,
      {
        headers: {
          token: getToken()
        }
      }
    );

    if (action.onSuccess) {
      localStorage.setItem('devTools', JSON.stringify(resp.data.data));
      action.onSuccess(resp.data && resp.data.data || {});
    }
  } catch (e) {
    console.log('e:', e)
  }
}

export function* postDevToolsConfig(action) {
    try {
      const resp = yield call(
        axiosT1.post,
        API.postDevToolConfigUrl,
        action.payload,
        {
          headers: {
            token: getToken()
          }
        }
      );
      if (action.onSuccess) {
        action.onSuccess(resp.data && resp.data.data || {});
      }
    } catch (e) {
        if(action.onError) {
            action.onError();
        }
      console.log('e:', e)
    }
}



export function feConfigSaga() {
  return [
     takeLatest(ACTIONS.DEV_TOOL_CONFIG.GET_DEV_TOOL_CONFIG, getDevToolsConfig),
     takeLatest(ACTIONS.DEV_TOOL_CONFIG.POST_DEV_TOOL_CONFIG, postDevToolsConfig)
  ]
}